import Grid from "components/primitives/Grid";
import useAthleteRagStatuses from "hooks/useAthleteRagStatuses";
import MonitoringIndicator from "./MonitoringIndicator";
import useMetadataActions from "providers/MetadataProvider/useMetadataActions";
import { memo, useCallback, useMemo } from "react";
import { Variants } from "types";

interface MonitoringIndicatorsRowProps {
  athleteId: string;
}

function MonitoringIndicatorsRow(props: MonitoringIndicatorsRowProps) {
  const { athleteId } = props;
  const getAthleteRagStatuses = useAthleteRagStatuses({ athleteIds: [] });
  const ragStatuses = getAthleteRagStatuses(athleteId);
  const { checkHasVariants } = useMetadataActions();

  const filterOpposingVariant = useCallback(
    (exerciseId: string, variant: Variants | null) => {
      const hasVariants = checkHasVariants(exerciseId);
      const shouldInclude = hasVariants ? Boolean(variant) === true : Boolean(variant) === false;
      return shouldInclude;
    },
    [checkHasVariants]
  );

  const ragStatusesWithValues = useMemo(() => {
    return ragStatuses?.map((ragStatus) => {
      return {
        ...ragStatus,
        values: ragStatus.values.filter(({ variant }) => filterOpposingVariant(ragStatus.metadataId, variant)),
      };
    });
  }, [ragStatuses, filterOpposingVariant]);

  return (
    <Grid container justifyContent="space-evenly" alignItems="center" height="100%">
      {ragStatusesWithValues?.map((ragStatus) => {
        return (
          <Grid key={ragStatus?.metadataId + "-" + athleteId} size={2} textAlign="center">
            <MonitoringIndicator
              athleteId={athleteId}
              hasValues={Boolean(ragStatus?.values.find((value) => value.progressArrow !== -2))}
              {...ragStatus}
            />
          </Grid>
        );
      })}
    </Grid>
  );
}

export default memo(MonitoringIndicatorsRow);
